import React from 'react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import Button from '../../../../components/Button';
import { BandVariantGroup } from '../BandVariantOptions/BandVariantOptions';
import styles from './BandVariantGroupSelector.module.scss';

interface BandDescriptionOptionsProps {
  selectedBandVariantGroup: BandVariantGroup;
  onVariantGroupSelect: (bandVariantGroup: BandVariantGroup) => void;
}

export default function BandVariantGroupSelector({
  selectedBandVariantGroup,
  onVariantGroupSelect,
}: BandDescriptionOptionsProps) {
  const { t } = useTranslation();
  return (
    <div className={styles.variantSelectorButtonGroup}>
      <Button
        className={classnames(styles.variantSelectorButton, {
          [styles.variantSelectorButtonSelected]: selectedBandVariantGroup === BandVariantGroup.FiOriginals,
        })}
        secondary={true}
        onClick={() => onVariantGroupSelect(BandVariantGroup.FiOriginals)}
      >
        {t('fi_originals')}
      </Button>
      <Button
        className={classnames(styles.variantSelectorButton, {
          [styles.variantSelectorButtonSelected]: selectedBandVariantGroup === BandVariantGroup.MakersEdition,
        })}
        secondary={true}
        onClick={() => onVariantGroupSelect(BandVariantGroup.MakersEdition)}
      >
        {t('premium_editions')}
      </Button>
    </div>
  );
}
